<div [ngClass]="themeClass()">
  <div class="chat-dialog-header__container">
    <mat-icon>auto_awesome</mat-icon>
    <h5 class="chat-dialog-header__title">{{ title() | translate }}</h5>
    @if (showFaqButton()) {
      <coin-v2-button
        class="chat-dialog-header__faq-button"
        type="outline"
        [icon]="icon()"
        [text]="faqLabel() | translate"
        (click)="faqPress.emit()" />
    }
    <button
      class="chat-dialog-header__close no-style"
      [attr.aria-label]="'general.close' | translate"
      (click)="closePress.emit()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-icon class="chat-dialog-header__drag-handle">drag_handle</mat-icon>
</div>
